import { useState } from 'react'
import { toast } from 'react-toastify';
import { Modal } from 'reactstrap';
import { IUser } from 'src/services/types';
import { deleteUsersInBulk } from 'src/services/users-service';
import { X } from 'feather-icons-react';

interface IProps {
    show: boolean;
    onClose: () => void;
    onRefresh: () => void;
    onRemoveSelectedUser: (id: string) => void;
    users: IUser[];
} 
export const ConfirmUsersDeleteModal = ({ show, onClose, users, onRefresh, onRemoveSelectedUser }: IProps) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onDelete = async () => {
        if (users.length === 0){
            toast.error('Please select at least one user to delete');
            onClose();
            return;
        }
        setError('');
        setLoading(true);
        try {
            const ids = users.map(user => user.id);
            const res = await deleteUsersInBulk(ids);
            console.log('res', res);
            if (res.result === 'ok') {
                onRefresh();
                onClose();
                toast(res?.message, { type: 'success'});
            } else {
                setError(res.message || 'An error has occurred, please try again later');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError('An error has occurred, please try again later');
        }
    }

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        size='lg'   
    >
           <>
                <div className="modal-body">
                    <div className='col-sm-12 p-3'>
                        <div className='row mb-3 rounded py-2' style={{backgroundColor: '#fd625e1a'}}>
                            <h4 style={{color: '#000'}}>
                                Confirm Delete Users
                            </h4>
                        </div>
                        <div className='row'>
                            <div className='col-sm-12 mb-3'>
                                Are you sure you want to delete the {users.length} users?
                            </div>
                            <div className='d-flex justify-content-center align-items-center'>
                                <table>
                                    <tbody>
                                        {users.map(user => (
                                            <tr key={user.id} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ width: '160px' }}>
                                                    <div 
                                                        className="d-flex justify-content-start align-items-center gap-2 custom-avatar" 
                                                    >
                                                        <img
                                                            src={user?.imagePath}
                                                            alt="image-user"
                                                            className="avatar-sm rounded-circle"
                                                            style={{ width: '28px', height: '28px' }}
                                                        />
                                                        <div className="custom-button" style={{ fontSize: '12px' }}>
                                                            {user?.firstName} {user?.lastName}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '200px' }}>
                                                    <div className="custom-button" style={{ fontSize: '12px' }}>
                                                        {user?.email}
                                                    </div>
                                                </td>
                                                <td className=''>
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-danger btn-sm waves-effect waves-light my-1"
                                                        onClick={() => onRemoveSelectedUser(user.id)}
                                                    >
                                                        remove <X size="16"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {
                        error  && 
                        <div className='col-sm-12 p-3'>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className='alert alert-danger' role='alert'>
                                        {error}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-soft-danger waves-effect waves-light"
                        onClick={() => onDelete()}
                    >
                        {
                           loading ? 
                            <><i className="fas fa-spinner fa-spin"></i> <span>Deleting...</span></>
                            : 'Yes, delete users'
                        }
                    </button>
                    <button type="button" className="btn btn-soft-secondary" onClick={onClose}>
                        No, cancel
                    </button>
                </div>
            </>
    </Modal>
  )
}
